export interface RuntimeConfig {
  appName: string
  teamName: string
  reportEmail: string
  googleClientId: string
  donation: {
    bankName: string
    bankCode: string
    account: string
    qrImage: string
  }
}

let cached: Promise<RuntimeConfig> | null = null

export function loadRuntimeConfig() {
  cached ??= fetch('/runtime-config.json', { cache: 'no-store' }).then(async (response) => {
    if (!response.ok) throw new Error('本機公開設定尚未產生，請先執行 npm run prepare:local')
    return (await response.json()) as RuntimeConfig
  })
  return cached
}

